import { useState, useEffect, Fragment } from 'react';
import { Modal, Badge } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { formatNumber } from '../../utils/generalFunctions';

import { obtenerCita, statusCita } from '../../actions/citas';

const DetallesCita = ({ cita, reestablecerCita, editarCita, eliminarCita }) => {

    const dispatch = useDispatch();

    const { detalles } = useSelector(state => state.citas);
    const { usuario } = useSelector(state => state.auth);

    const [detallesModal, setDetallesModal] = useState(false);

    const [citaData, setCitaData] = useState({
        id: null,
        locatario: null,
        servicio_elegido: null,
        contratacion: null,
        total: null,
        metodo: null,
        fecha_inicio: null,
        fecha_fin: null,
        hora_inicio: null,
        hora_fin: null,
        observaciones: null,
        status: 0,
        pagada: false
    });

    const [mostrarFinalizar, setMostrarFinalizar] = useState(false);
    const [mostrarCancelar, setMostrarCancelar] = useState(false);
    const [mostrarDescancelar, setMostrarDescancelar] = useState(false);
    const [mostrarAcciones, setMostrarAcciones] = useState(false);

    const handleCerrar = () => {
        setCitaData({
            id: null,
            locatario: null,
            servicio_elegido: null,
            contratacion: null,
            total: null,
            metodo: null,
            fecha_inicio: null,
            fecha_fin: null,
            hora_inicio: null,
            hora_fin: null,
            observaciones: null,
            status: 0,
            pagada: false
        });

        setDetallesModal(false);
        reestablecerCita(null);
    }

    const handleEditar = () => {
        handleCerrar();
        editarCita(citaData);
    }

    const handleStatus = (status) => {
        dispatch(statusCita({
            id: citaData.id,
            status
        }));
        handleCerrar();
    }

    const handleEliminar = () => {
        handleCerrar();
        eliminarCita(citaData);
    }

    const convertMetodo = (metodo) => {
        switch(metodo){
            case 0:
                return 'Efectivo';
            case 1:
                return 'Tarjeta';
            case 2:
                return 'Transferencia';
            default:
                return 'Sin elegir';
        }
    }

    useEffect(() => {
        dispatch(obtenerCita(null));
    }, []);

    useEffect(() => {
        if(cita){
            setDetallesModal(true);

            dispatch(obtenerCita(cita?.id));

            setCitaData({
                ...citaData,
                id: cita?.id
            });
        }
    }, [cita]);

    useEffect(() => {
        if(detalles){
            setCitaData({
                ...citaData,
                id: detalles?._id,
                locatario: detalles?.locatario,
                servicio_elegido: detalles?.servicio_elegido,
                contratacion: detalles?.contratacion,
                total: detalles?.total,
                metodo: detalles?.metodo,
                fecha_inicio: detalles?.fecha_inicio,
                fecha_fin: detalles?.fecha_fin,
                hora_inicio: detalles?.hora_inicio,
                hora_fin: detalles?.hora_fin,
                observaciones: detalles?.observaciones,
                status: detalles?.status,
                pagada: detalles?.pagada
            });

            let fecha_inicio_pasada = detalles?.fecha_inicio ? new Date(detalles.fecha_inicio) < new Date() : false;

            setMostrarFinalizar(detalles?.status == 0 && fecha_inicio_pasada && detalles?.pagada);
            setMostrarCancelar(detalles?.status == 0);
            setMostrarDescancelar(detalles?.status == 2);
            setMostrarAcciones(detalles?.status == 0);
        }
    }, [detalles, usuario]);

    return (
        <Fragment>
            <Modal show={detallesModal} backdrop="static" size="lg" centered onHide={() => handleCerrar()}>
                <Modal.Header closeButton>
                    <Modal.Title>Cita de servicio</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="row">
                        <div className="col-md-4">
                            <label className="fw-bold">Fecha</label>
                            <p>{ citaData?.fecha_inicio ? new Date(citaData?.fecha_inicio).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Sin definir' }</p>
                        </div>

                        <div className="col-md-3">
                            <label className="fw-bold">Horario</label>
                            <p>{citaData?.hora_inicio + ' - ' + citaData?.hora_fin}</p>
                        </div>

                        <div className="col-md-5">
                            <label className="fw-bold">Servicio</label>
                            <p>{citaData?.servicio_elegido?.nombre || 'Sin servicio elegido'}</p>
                        </div>

                        <div className="col-md-5">
                            <label className="fw-bold">Locatario</label>
                            <p>{citaData?.locatario?.servicio ? citaData?.locatario?.servicio + ` (${citaData?.locatario?.nombre})` : citaData?.locatario?.nombre}</p>
                        </div>

                        <div className="col-md-7">
                            <label className="fw-bold">Paquete</label>
                            <p>{citaData?.contratacion?.nombre_paquete || 'Sin paquete elegido'}</p>
                        </div>

                        <div className="col-md-3">
                            <label className="fw-bold">Total</label>
                            <p>{formatNumber(citaData?.total || 0, 2, '$ ', '')}</p>
                        </div>

                        <div className="col-md-3">
                            <label className="fw-bold">Método de pago</label>
                            <p>{citaData?.contratacion?.nombre_paquete ? 'No aplica' : convertMetodo(citaData?.metodo)}</p>
                        </div>

                        <div className="col-md-3">
                            <label className="fw-bold">Status de cita</label>
                            <h5 className="text-muted">
                                <Badge bg={citaData?.status == 0 ? 'warning' : (citaData?.status == 1 ? 'success' : 'danger')}>
                                    {citaData?.status == 0 ? 'Agendada' : (citaData?.status == 1 ? 'Finalizada' : 'Cancelada')}
                                </Badge>
                            </h5>
                        </div>

                        <div className="col-md-3">
                            <label className="fw-bold">Status de pago</label>
                            <h5 className="text-muted">
                                <Badge bg={citaData?.pagada ? 'success' : 'danger'}>
                                    {citaData?.pagada ? 'Pagada' : 'Pendiente'}
                                </Badge>
                            </h5>
                        </div>

                        <div className="col-md-12">
                            <label className="fw-bold">Observaciones</label>
                            <p>{citaData?.observaciones ? citaData?.observaciones : 'Sin observaciones'}</p>
                        </div>
                    </div>
                </Modal.Body>

                {
                    mostrarFinalizar || mostrarCancelar || mostrarDescancelar || mostrarAcciones ?
                        <Modal.Footer>
                            {
                                mostrarFinalizar ?
                                    <button type="button" className="btn btn-success" onClick={() => handleStatus(1)}><i className="fas fa-check fa-sm"></i> Finalizar</button>
                                :
                                    null
                            }

                            {
                                mostrarCancelar ?
                                    <button type="button" className="btn btn-danger" onClick={() => handleStatus(2)}><i className="fas fa-times fa-sm"></i> Cancelar</button>
                                :
                                    null
                            }

                            {
                                mostrarDescancelar ?
                                    <button type="button" className="btn btn-warning" onClick={() => handleStatus(0)}><i className="fas fa-refresh fa-sm"></i> Revertir cancelación</button>
                                :
                                    null
                            }

                            {
                                mostrarAcciones ?
                                    <>
                                        <button type="button" className="btn btn-warning" onClick={() => handleEditar()}><i className="fas fa-pencil fa-sm"></i> Editar</button>
                                        <button type="button" className="btn btn-danger mr-3" onClick={() => handleEliminar()}><i className="fas fa-trash fa-sm"></i> Eliminar</button>
                                    </>
                                :
                                    null
                            }
                        </Modal.Footer>
                    :
                        null
                }
            </Modal>
        </Fragment>
    )
}

export default DetallesCita;
